import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
  Fade,
  Backdrop,
} from '@material-ui/core';
import {
  Warning,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      background: '#00191e',
      border: '3px solid rgba(255, 255, 255, 0.05)',
      boxShadow: '0 8px 32px rgba(255, 255, 255, 0.02)',
      minWidth: '500px',
      maxWidth: '600px',
    },
  },
  dialogContent: {
    padding: '24px',
    backgroundColor: '#00191e',
    color: 'white',
    textAlign: 'center',
  },
  headerSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    gap: '12px',
  },
  warningIcon: {
    fontSize: '24px',
    color: '#FF4842',
  },
  titleText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#FF4842',
  },
  warningMessage: {
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '24px',
    fontWeight: '400',
  },
  materialName: {
    color: '#B72136',
    fontWeight: 'bold',
  },
  dialogActions: {
    padding: '16px 24px',
    backgroundColor: '#00191e',
    borderRadius: '0 0 12px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
  },
  cancelButton: {
    backgroundColor: 'transparent',
    color: '#ccc',
    border: '1px solid #666',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#3a3a3a',
      borderColor: '#888',
    },
  },
  confirmButton: {
    backgroundColor: '#FF4842',
    color: 'white',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ff5252',
    },
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(4px)',
  },
}));

const WarningMaterialPopup = ({ open, onClose, onConfirm, message, materialName, qty }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      BackdropComponent={Backdrop}
      BackdropProps={{
        className: classes.backdrop,
      }}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
    >
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.headerSection}>
          <Warning className={classes.warningIcon} />
          <Typography className={classes.titleText}>
            Material Warning
          </Typography>
        </Box>
        
        <Typography className={classes.warningMessage}>
          This material is not included in any product formula.
        </Typography>
        <Typography className={classes.warningMessage}>
          Are you sure you want to add{' '}
          <span className={classes.materialName}>{qty} quantity</span> of{' '}
          <span className={classes.materialName}>{materialName}</span> to additional materials?
        </Typography>
      </DialogContent>
      
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          className={classes.cancelButton}
        >
          CANCEL
        </Button>
        <Button
          onClick={onConfirm}
          className={classes.confirmButton}
        >
          YES, ADD IT
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningMaterialPopup;
